import React from 'react';
import { Col, FormText } from 'reactstrap';

export default function HelpText({ helpText }) {
  if (!helpText) return null;
  return (<Col className="label-help"><FormText>{ helpText }</FormText></Col>);
}
